// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal","Blur":"Blur","ModalDialog":"ModalDialog","modal-content":"modal-content","ModalBody":"ModalBody","CloseButton":"CloseButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Modal/styles.scss
// module id = 1978
// module chunks = 10